import { useRef, useEffect, useCallback } from 'react';

// ----------------------------------------------------------------------

export function useMessagesScroll(messages) {
  const messagesEndRef = useRef(null);
  const prevFirstMessageIdRef = useRef(null);
  const prevLengthRef = useRef(0);

  const scrollToBottom = useCallback(() => {
    const container = messagesEndRef.current;
    if (!container) return;
    container.scrollTop = container.scrollHeight;
  }, []);

  const scrollToLastUserMessage = useCallback(() => {
    const container = messagesEndRef.current;
    if (!container) return;

    const scrollable =
      container.querySelector?.('.simplebar-content-wrapper') ?? container;

    const userBubbles = scrollable.querySelectorAll?.('[data-chat-message="user"]');
    const lastUserBubble = userBubbles?.length ? userBubbles[userBubbles.length - 1] : null;

    if (!lastUserBubble) {
      scrollToBottom();
      return;
    }

    const TOP_PADDING = 24; // px
    const containerRect = scrollable.getBoundingClientRect();
    const bubbleRect = lastUserBubble.getBoundingClientRect();
    const relativeTop = bubbleRect.top - containerRect.top;
    scrollable.scrollTop = scrollable.scrollTop + relativeTop - TOP_PADDING;
  }, [scrollToBottom]);

  useEffect(() => {
    if (!messages || messages.length === 0) {
      prevLengthRef.current = 0;
      prevFirstMessageIdRef.current = null;
      return;
    }

    const currentLength = messages.length;
    const currentFirstMessageId = messages[0].id;

    scrollToLastUserMessage();
    prevLengthRef.current = currentLength;
    prevFirstMessageIdRef.current = currentFirstMessageId;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages]);

  return { messagesEndRef };
}
